import { render, staticRenderFns } from "./Customer.vue?vue&type=template&id=81ff3f48&scoped=true"
import script from "./Customer.vue?vue&type=script&lang=ts"
export * from "./Customer.vue?vue&type=script&lang=ts"
import style0 from "./Customer.vue?vue&type=style&index=0&id=81ff3f48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_169bdbd7e32539014db8c98595250064/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ff3f48",
  null
  
)

export default component.exports